import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoFormaPagamentoMultiselectComponent } from './novo-forma-pagamento-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoFormaPagamentoMultiselectComponent],
  exports: [NovoFormaPagamentoMultiselectComponent]
})
export class NovoFormaPagamentoMultiselectModule {}
